import { Text } from '@thanx/uikit/text'
import { ReactComponent as ExternalLinkIcon } from 'assets/images/ic-external-link.svg'
import { buildTranslate } from 'locales'
import { customerProfileUrl } from 'utilities/urlUtils'

const t = buildTranslate('segments.details')

interface SampleCustomerRowProps {
  customer: {
    id: string
    customer_name: string
    customer_email: string
    lifetime_spend: number | string
    days_since_last_visit: number | null
    loyalty_tier: string | null
  }
  index: number
  isLast: boolean
}

const SampleCustomerRow = ({
  customer,
  index,
  isLast,
}: SampleCustomerRowProps) => {
  return (
    <tr
      className="sample-customer-row"
      style={{
        borderBottom: isLast ? 'none' : '1px solid #e9eaec',
        borderTop: index === 0 ? 'none' : undefined,
      }}
    >
      <td
        className="py-3 px-3"
        style={{
          width: '280px',
          verticalAlign: 'middle',
          borderTop: index === 0 ? 'none' : undefined,
        }}
      >
        <div className="d-flex flex-column" style={{ gap: '4px' }}>
          <Text.BodyText4 color="grey90" className="font-weight-bold">
            {customer.customer_name}
          </Text.BodyText4>
          <Text.BodyText5 color="grey70">
            {customer.customer_email}
          </Text.BodyText5>
        </div>
      </td>
      <td
        className="py-3 px-3"
        style={{
          width: '180px',
          verticalAlign: 'middle',
          borderTop: index === 0 ? 'none' : undefined,
        }}
      >
        <div className="d-flex flex-column" style={{ gap: '4px' }}>
          <Text.BodyText5 color="grey70">
            {t('sample_customers.lifetime_spend')}
          </Text.BodyText5>
          <Text.BodyText4 color="grey90" className="font-weight-bold">
            $
            {typeof customer.lifetime_spend === 'number'
              ? customer.lifetime_spend.toFixed(2)
              : parseFloat(customer.lifetime_spend || '0').toFixed(2)}
          </Text.BodyText4>
        </div>
      </td>
      <td
        className="py-3 px-3"
        style={{
          width: '180px',
          verticalAlign: 'middle',
          borderTop: index === 0 ? 'none' : undefined,
        }}
      >
        <div className="d-flex flex-column" style={{ gap: '4px' }}>
          <Text.BodyText5 color="grey70">
            {t('sample_customers.days_since_last_visit')}
          </Text.BodyText5>
          <Text.BodyText4 color="grey90" className="font-weight-bold">
            {customer.days_since_last_visit !== null
              ? t('sample_customers.days_count', {
                  days: customer.days_since_last_visit,
                })
              : t('sample_customers.not_available')}
          </Text.BodyText4>
        </div>
      </td>
      <td
        className="py-3 px-3"
        style={{
          width: '150px',
          verticalAlign: 'middle',
          borderTop: index === 0 ? 'none' : undefined,
        }}
      >
        <div className="d-flex flex-column" style={{ gap: '4px' }}>
          <Text.BodyText5 color="grey70">
            {t('sample_customers.loyalty_tier')}
          </Text.BodyText5>
          <Text.BodyText4 color="grey90" className="font-weight-bold">
            {customer.loyalty_tier || t('sample_customers.no_tier')}
          </Text.BodyText4>
        </div>
      </td>
      <td
        className="py-3 px-3 text-right"
        style={{
          width: '140px',
          verticalAlign: 'middle',
          borderTop: index === 0 ? 'none' : undefined,
        }}
      >
        <a
          // customer.id, not a uid — pre-existing, out of scope here.
          href={customerProfileUrl(customer.id)}
          target="_blank"
          rel="noopener noreferrer"
          className="d-flex align-items-center justify-content-end text-decoration-none"
          style={{ gap: '4px' }}
        >
          <ExternalLinkIcon width="15" height="15" style={{ flexShrink: 0 }} />
          <Text.BodyText4 tag="span" className="mb-0" color="primary">
            {t('sample_customers.view_profile')}
          </Text.BodyText4>
        </a>
      </td>
    </tr>
  )
}

export default SampleCustomerRow
